<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <loader v-if="loading"/>

    <div v-else>

      <b-row>
        <b-col xl="6">

          <card-with-aside
              class="px-5 py-3"
              :title="fields.event.title"
              :asideLeftWidth="0">
            <template slot="body">
              <form-builder
                  @submit="debounceSubmit"
                  @send-image="value => createImageObject(value)"
                  class="px-3"
                  :labelBlockWith="3"
                  :inline="true"
                  :fields="fields.event.items"
                  hideField="id"
                  :showDuplicateButton="true"
                  @duplicate="duplicate"
                  :prefillParams="prefillParams"
              />
            </template>

          </card-with-aside>

        </b-col>
        <b-col xl="6">
          <card-with-aside
              class="px-5 py-3"
              :title="fields.tickets.title"
              :asideLeftWidth="0">

            <template slot="titleButton">
              <b-button
                  @click="() => {$bus.$emit('openCreateTicketsModal')}"
                  variant="outline-secondary"
                  size="sm"
                  class="py-0 ml-2"
              >{{$t('button.add')}}
              </b-button>
            </template>

            <template slot="body">

              <div v-if="!prefillParams.tickets || !prefillParams.tickets.length"
                   class="text-muted text-center">
                {{$t('global.no_data')}}
              </div>

              <div v-else class="mt-2">

                <b-card
                    no-body
                    class="mb-1 border-0"
                    v-for="(ticket, index) in prefillParams.tickets"
                    :key="index">

                  <b-card-header
                    header-tag="header"
                    class="py-3 px-4 pointer border-0"
                    role="tab"
                    v-b-toggle="'ticket-' + index">

                    <div class="d-flex flex-row justify-content-between align-items-center">

                      <div>
                        <i class="fas fa-sort-down mr-3"></i>
                        <span>{{ticket.title}}</span>
                      </div>

                      <div>
                        <span
                          class="mr-2">{{ticket.price.toLocaleString()}} {{ticket.currency.value}}</span>

                        <b-badge
                          :variant="ticket.active ? 'success': 'info'"
                          class="text-white ml-2 font-weight-light"
                          style="font-size: 12px">
                          {{ticket.active ? $t('form.active') : $t('form.inactive')}}
                        </b-badge>

                        <b-badge
                          :variant="ticket.is_public ? 'success' : 'info' "
                          class="text-white ml-2 font-weight-light"
                          style="font-size: 12px">
                          {{ticket.is_public ? $t('form.public') : $t('form.private') }}
                        </b-badge>
                      </div>

                    </div>

                  </b-card-header>


                  <b-collapse :id="'ticket-'+index" accordion="my-accordion" role="tabpanel">

                    <b-card-body class="position-relative d-flex flex-column pt-3 px-4 pb-0">
                      <form-fields
                          :showSubmitButton="false"
                          :labelBlockWith="3"
                          :inline="true"
                          :fields="fields.tickets.items"
                          :prefillParams="ticket"
                      />

                      <b-btn
                          class="align-self-end p-0"
                          @click="() => {$bus.$emit('openDeleteTicketModal', index)}"
                          variant="link">
                        <u class="text-secondary">{{$t('button.delete')}}</u>
                      </b-btn>
                    </b-card-body>

                  </b-collapse>
                </b-card>
              </div>

            </template>

          </card-with-aside>
        </b-col>

      </b-row>

      <b-row>
        <b-col>
          <card-with-aside
              class="px-5 py-3"
              :title="$t('plan.access_rules')"
              :asideLeftWidth="0">

            <template slot="body">
              <TaxonomiesView
                  v-show="!params.full_access"
                  :submit="submit"
                  @submit="eventFormSubmit"
                  :prefillParams="prefillTaxonomies"/>
            </template>
          </card-with-aside>
        </b-col>
      </b-row>

      <!-- tickets modal-->
      <modal
          name="CreateTickets"
          :confirm="$t('button.save')"
          :title="$t('tievent.add_ticket')"
          :preventHideOnOk="true"
          @ok="okButtonPressed">

        <template slot="body">

            <form-fields
                v-if="fields.tickets"
                @submit="data => { ticketFormSubmit(data) }"
                :emitSubmitForm="emitSubmitForm"
                :clearFields="clearFields"
                :showSubmitButton="false"
                class="px-3"
                :labelBlockWith="3"
                :inline="true"
                :fields="fields.tickets.items"
                hideField="id"
                :prefillParams="{...ticketModel}"
            />

        </template>

      </modal>

      <!--delete ticket modal-->
      <modal
          name="DeleteTicket"
          @ok="index => {deleteTicket(index)}">

        <template slot="body">
          <h5 class="text-center">{{$t('tievent.delete_ticket')}}</h5>
        </template>

      </modal>

    </div>
  </div>
</template>

<script>
  import formFields from '@/components/global/formFields';
  import formBuilder from '@/components/global/formBuilder';
  import TaxonomiesView from '@/views/tickets/TaxonomiesView.vue'
  import fields from '@/views/tickets/ti-events.fields';
  import ImageUpload from '@/components/global/imageUpload'
  import {formattedDateForBrowsers} from "../../utils/date-utils";

  export default {
    name: "TiEventView",
    props: {
      id: {
        default: null
      },
      editing: {
        type: Boolean,
        default: false
      }
    },
    components: {
      'formFields': formFields,
      formBuilder,
      TaxonomiesView,
      ImageUpload
    },
    data: () => {
      return {
        formColumns: 12,
        labelBlockWith: 3,
        mb: 4,
        clearFields: false,
        ticket: {},
        submit: false,
        emitSubmitForm: false,
        ticketModel: {
          title: "",
          description: "",
          price: "0.00",
          currency: "USD",
          quantity: 0,
          mailchimp_tags: [],
          attach_subscription_id: null,
          plan_discounts: [],
          min_quantity_order: 0,
          max_quantity_order: 0,
          active: true,
          is_public: true,
          start_date: null,
          end_date: null,
          vat_percent: 0,
          is_applied_vat: false,
        },
        formValidated: false,
        loading: false,
        paramsMutated: {},
        prefillParams: {
          full_access: true,
          tickets: []
        },
        params: {
          full_access: false
        },
        prefillTaxonomies: [],
        fields: fields,
        ticketModal: false,
        debounceSubmit: () => {
        }
      }
    },
    watch: {
      id () {
        this.setPrefillData()
      }
    },
    created() {
      if (this.id) { this.setPrefillData() }

      this.$store.dispatch('currency/getCurrency');
      this.debounceSubmit = _.debounce(this.emitSubmit, 1000);
    },
    methods: {
      setPrefillData () {
        this.loading = true;

        this.getData(`ti-event/${this.id}`, null, false)
          .then(({ data }) => {

            if (data) {

              const events = this.fields.event.items;

              this.prefillParams = data;
              this.prefillParams.tickets.map(item => item.id = item.id.toString());
              this.prefillTaxonomies = [];

              if (this.prefillParams.taxonomies) {
                this.concatPrefillTaxonomies(this.prefillParams.taxonomies);
              }
              if (this.prefillParams.content_types) {
                this.concatPrefillTaxonomies(this.prefillParams.content_types, true);
              }

              this.prefillParams = (({ tickets, start_date, end_date, location, timezone, ...rest }) => ({
                tickets: tickets.map(({id, start_date, end_date, price, extra, plan_discounts, is_private, ...rest}) => ({
                  id: id.toString(),
                  price: price,
                  is_public: !is_private,
                  ...rest,
                  mailchimp_tags: extra ? extra.mailchimp_tags || [] : [],
                  attach_subscription_id: extra ? extra.attach_subscription_id || null : null,
           /*       date: ((start_date !== null) && (end_date !== null)) ? {
                    start: (start_date !== null) ? new Date(start_date) : '',
                    end: (end_date !== null) ? new Date(end_date) : ''
                  } : null,*/
                  start_date: formattedDateForBrowsers(start_date),
                  end_date: formattedDateForBrowsers(end_date),
                  plan_discounts: plan_discounts.map((item) => {
                   return {
                     ...item,
                     discount: item.discount_type === 'amount' ? this.formatToDollars(item.discount) : item.discount,
                   }
                  })
                })),
    /*            date: {
                  start: new Date(start_date),
                  end: new Date(end_date)
                },*/
                start_date: formattedDateForBrowsers(start_date),
                end_date: formattedDateForBrowsers(end_date),
                location: location,
                timezone: this.getDefaultOption(events, timezone, "timezone"),
                ...rest
              }))({...data, ...this.prefillParams});
            }

          }).then(() => {

          this.loading = false;
          this.$forceUpdate()
        })
      },
      getDefaultOption (fields, option, type) {
        return (({options}) => options.filter(({value}) => value === option).shift())(fields.filter(({name}) => name === type).shift())
      },
      concatPrefillTaxonomies(taxonomies, content_type = false) {
        if (!Array.isArray(taxonomies)) return;

        let sortTermsByParams = (terms) => {
          if (!Array.isArray(terms)) return;

          let termsSortedByParams = {};

          terms.forEach((term) => {
            const termsParamsKey = term.access_limit + term.access_limit_period + String(term.exclude);

            if (termsSortedByParams[termsParamsKey]) {
              termsSortedByParams[termsParamsKey].push(term);
            } else {
              termsSortedByParams[termsParamsKey] = [term];
            }
          });

          return termsSortedByParams;
        };

        if (content_type) {
          const sortedContentTypeTerms = sortTermsByParams(taxonomies);

          if (!sortedContentTypeTerms) return;

          Object.keys(sortedContentTypeTerms).forEach((key) => {
            this.prefillTaxonomies.push({
              title: this.$t('event.content_type'),
              id: 'content_type',
              terms: sortedContentTypeTerms[key]
            });
          });
        } else {
          taxonomies.forEach((taxonomy) => {
            const sortedContentTypeTerms = sortTermsByParams(taxonomy.terms);

            if (!sortedContentTypeTerms) return;

            Object.keys(sortedContentTypeTerms).forEach((key) => {
              this.prefillTaxonomies.push({
                title: taxonomy.title,
                id: taxonomy.id,
                key: taxonomy.key,
                terms: sortedContentTypeTerms[key]
              });
            });
          });
        }
      },
      createImageObject(formData) {
        this.params.photo = formData;
      },
      emitSubmit() {
        this.submit = !this.submit;
      },
      eventFormSubmit(data) {
        this.paramsMutated = (({start_date, end_date, location, timezone, status, is_public, ...rest }) => ({
/*          start_date: date ? this.formatDate(date.start, "MM/DD/YYYY hh:mm:ss a") : '',
          end_date: date ? this.formatDate(date.end, "MM/DD/YYYY hh:mm:ss a") : '',*/
          location: location,
          timezone: timezone.value,
          start_date: this.formatDate(start_date, "MM/DD/YYYY hh:mm:ss a"),
          end_date: this.formatDate(end_date, "MM/DD/YYYY hh:mm:ss a"),
          ...rest
        }))({...this.prefillParams, ...data});

        this.paramsMutated.private = !this.paramsMutated.public;
        this.paramsMutated.active = this.paramsMutated.active || false;

        new Promise((resolve) => {
          this.paramsMutated.taxonomies = data.taxonomies;
          this.paramsMutated.content_types = data.content_types;
          resolve(this.paramsMutated)
        }).then(data => {
          if (this.editing) {
            return this.putData(`ti-event/${this.id}`, data).then(({data}) => {
              return data.id
            })
          } else {
            return this.postData('ti-event', data).then(({data}) => {
              return data.id
            })
          }
        }).then(eventId => {
          if (eventId && this.params.photo) {
            if (!Array.isArray(this.params.photo)) {
              return this.postData(`ti-event/${eventId}/photo`, this.params.photo).then(({data}) => {
                return data.id
              })
            }
          }
          return eventId
        }).then(eventId => {
          // if (eventId && (typeof this.params.tickets !== 'undefined' && this.params.tickets.length > 0)) {
          if (eventId) {
            this.paramsMutated.tickets.forEach((ticket, index) => {
              let event_ticket = (({id, start_date, end_date, title, plan_discounts, price, currency, max_quantity_order, min_quantity_order, quantity, is_public, ...rest}) => ({
                id: id,
                title: title,
                slug: this.slugify(title),
                quantity: Number(quantity),
                max_quantity_order: Number(max_quantity_order),
                min_quantity_order: Number(min_quantity_order),
/*                start_date: (date !== null) ? this.formatDate(date.start, "L") : '',
                end_date: (date !== null) ? this.formatDate(date.end, "L") : '',*/
                start_date: this.formatDate(start_date, 'MM/DD/YYYY hh:mm:ss a'),
                end_date: this.formatDate(end_date, 'MM/DD/YYYY hh:mm:ss a'),
                is_private: !is_public,
                price: this.formatToCents(price),
                plan_discounts: Array.isArray(plan_discounts) ? plan_discounts.map((item) => {
                  const discount_type = item.discount_type ? item.discount_type.value : null;

                  return {
                    active: item.active,
                    discount: discount_type === 'amount' ? this.formatToCents(item.discount) : item.discount,
                    discount_type: discount_type,
                    currency: this.formatValue(item.currency),
                    plan_id: item.plan_id ? item.plan_id.id : null
                  }
                }) : null,
                currency: this.formatValue(currency),
                ti_event_id: Number(eventId),
                ...rest,
                extra: {
                  mailchimp_tags: ticket.mailchimp_tags,
                  attach_subscription_id: ticket.attach_subscription_id ? ticket.attach_subscription_id.id : null
                },
              }))(ticket);

              if (ticket.id) {
                this.putData(`ti-event/ticket/${ticket.id}`, event_ticket, null, true);
              } else {
                this.postData('ti-event/ticket', event_ticket, null, true).then(({data}) => {
                  this.paramsMutated.tickets[index] = data
                });
              }
            });
            return eventId;
          }
        }).then(eventId => {
          if (!this.editing) {
            this.$router.push({path: `/tievents/edit/${eventId}`});
          }
        });
      },
      ticketFormSubmit(data) {
        this.ticket = data;
        this.addReactiveItemToArray(this.prefillParams.tickets, this.ticket);
        this.$bus.$emit('closeCreateTicketsModal');
        this.clearFields = true;
        this.$forceUpdate();
      },
      okButtonPressed() {
        this.emitSubmitForm = !this.emitSubmitForm;
        this.$forceUpdate()
      },
      deleteTicket(index) {
        if (Array.isArray(this.prefillParams.tickets)) {
          const ticket = this.prefillParams.tickets[index];
          if (ticket.id) {
            this.deleteData(`ti-event/ticket/${ticket.id}`)
          }
          this.deleteItemByIndex(this.prefillParams.tickets, index)
        }
      },
      duplicate(id) {
        this.postData(`/ti-event/${id}/copy`).then(resp => {
          if (resp) {
            this.$router.push(`/tievents/edit/${resp.data.id}`)
          }
        })
      }
    }
  }
</script>
